import { forwardRef, type ComponentPropsWithoutRef } from 'react';

import { cn } from '@/lib/utils';

export interface FormTextareaProps extends ComponentPropsWithoutRef<'textarea'> {
  error?: boolean;
}

export const FormTextarea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  ({ error, className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        aria-invalid={error ? 'true' : undefined}
        className={cn(
          'bg-background w-full rounded-md border px-3 py-2 text-sm outline-none',
          'focus-visible:ring-primary focus-visible:ring-2',
          'transition-colors',
          error ? 'border-destructive focus-visible:ring-destructive' : 'border-input',
          className,
        )}
        {...props}
      />
    );
  },
);

FormTextarea.displayName = 'FormTextarea';
